// Must stay in lockstep with backend validation (POST /support-chat/messages).
export const MAX_MESSAGE_LENGTH = 4000;

export const STORAGE_KEY_PREFIX = "support-chat:";

// Socket.IO namespace, appended to the API origin in the io() URL.
export const NAMESPACE_PATH = "/support-chat";

// Safety cap on persisted messages — worst case ~800KB at full message length,
// well under localStorage quota.
export const MESSAGES_PERSIST_CAP = 200;

// Data attribute that marks an element as a support-chat trigger. Elements with
// this attribute are excluded from the widget's outside-click handler so a
// click on the trigger doesn't immediately close the widget it just opened.
// Used as both a JSX prop (key) and a CSS selector — keep them in sync via
// `TRIGGER_ATTR_SELECTOR`.
export const TRIGGER_ATTR = "data-support-chat-trigger";
export const TRIGGER_ATTR_SELECTOR = `[${TRIGGER_ATTR}]`;

// The sidebar's own support entry, shared so anything else offering the widget
// (the command palette) shows the word the product already uses. "Get help" is
// what the sidebar says and what reviewers searched for; "Contact support" was
// a second name for one button.
export const SUPPORT_LABEL = "Get help";
